import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { vortxTypography } from '@vortx/shared-ui';

const TAGLINES = [
    "Energy, Unbound.",
    "Hardware-enforced power, software-defined intelligence.",
    "We Don't Build Projects. We Ship Infrastructure.",
    "Where energy infrastructure, intelligence, and control converge.",
    "Redefining Distributed Energy.",
];

const RetroTaglineRotator = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [displayText, setDisplayText] = useState('');
    const [isTyping, setIsTyping] = useState(true);

    useEffect(() => {
        const tagline = TAGLINES[currentIndex];

        if (isTyping) {
            // Typing effect
            if (displayText.length < tagline.length) {
                const timeout = setTimeout(() => {
                    setDisplayText(tagline.slice(0, displayText.length + 1));
                }, 50);
                return () => clearTimeout(timeout);
            } else {
                // Finished typing, wait then start erasing
                const timeout = setTimeout(() => {
                    setIsTyping(false);
                }, 3000);
                return () => clearTimeout(timeout);
            }
        } else {
            // Erasing effect
            if (displayText.length > 0) {
                const timeout = setTimeout(() => {
                    setDisplayText(displayText.slice(0, -1));
                }, 25);
                return () => clearTimeout(timeout);
            } else {
                // Finished erasing, move to next tagline
                setCurrentIndex((prev) => (prev + 1) % TAGLINES.length);
                setIsTyping(true);
            }
        }
    }, [displayText, isTyping, currentIndex]);

    return (
        <Box sx={{
            minHeight: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <Typography
                sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.8rem',
                    color: '#5fd4c4',
                    textShadow: '0 0 10px rgba(95, 212, 196, 0.5)',
                    letterSpacing: '0.05em',
                }}
            >
                {displayText}
                <Box
                    component="span"
                    sx={{
                        display: 'inline-block',
                        width: 8,
                        height: 16,
                        background: '#5fd4c4',
                        marginLeft: 0.5,
                        animation: 'cursorBlink 1s step-end infinite',
                        verticalAlign: 'middle',
                        '@keyframes cursorBlink': {
                            '0%, 50%': { opacity: 1 },
                            '51%, 100%': { opacity: 0 },
                        },
                    }}
                />
            </Typography>
        </Box>
    );
};

export default RetroTaglineRotator;
